import React, { useContext } from "react";
import { UserContext } from "./providers/UserContext";
import { RoutesComponent } from "./routes/routes";

export const App = () => {
  const { globalLoading } = useContext(UserContext);
  return (
    <>
      {globalLoading ? (
        <h1>Loading...</h1>
      ) : (
        <>
          <RoutesComponent />
        </>
      )}
    </>
  );
};
